export default __webpack_public_path__ + "static/product-reference-chart-mobile-7b656279a9d3bb6c6df54da9cf959346.png";